import { render } from "./ProductDesign.vue?vue&type=template&id=835d5618&scoped=true"
import script from "./ProductDesign.vue?vue&type=script&lang=js"
export * from "./ProductDesign.vue?vue&type=script&lang=js"

import "./ProductDesign.vue?vue&type=style&index=0&id=835d5618&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-835d5618"]])

export default __exports__